import RequestType from './RequestType'
import Employee from './Employee'
export class SaveRequestTypeRequest {
    RequestType: RequestType;
    SavedByEmployee: Employee;
}

export default SaveRequestTypeRequest;